import { Title, Subtitle, Field, SubmitButton, Modal } from '~components'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { object, string } from '~utils/validation'
import { useStore, usePathValidation, useNavigate } from '~hooks'
import { Values } from './interfaces'
import { useEffect, useState } from 'react'
import * as Styled from './styled'
import { Vehicle } from '~services'
import { useRequest } from 'ahooks'
import { VehicleBodiesData, VehicleTypesData } from '~services/interfaces'
import { track } from '@amplitude/analytics-browser'

function Cellphone() {
  const [open, setOpen] = useState(false)
  const store = useStore()
  const navigate = useNavigate()
  const modalButton = {
    text: 'WhatsApp',
    onClick: handleModalPrimaryClick,
    forWhatsApp: true,
  }

  const defaultValues = {
    cellphone: store.register?.cellphone || '',
  }
  const message = `Olá! Meu CPF é ${store.cpf}. Estou tentando acessar a Fretebras e pediram pra confirmar meus dados. Pode me ajudar?`
  const schema = object({
    cellphone: string().cellphone('Celular inválido.'),
  })
  const {
    register,
    handleSubmit,
    formState: { isValid, errors },
  } = useForm({ defaultValues, resolver: yupResolver(schema), mode: 'onChange' })

  usePathValidation(['cpf'])
  useEffect(() => {
    track('perfil_recadastro_telefone')
  }, [])

  useRequest(Vehicle.listTypes, {
    onSuccess: handleVehiclesTypesSuccess,
  })
  useRequest(Vehicle.listBodies, {
    onSuccess: handleVehiclesBodiesSuccess,
  })

  function onSubmit(values: Values) {
    store.update({ register: values })
    navigate('/cadastrar/nome-completo', {
      state: { previousPath: '/cadastrar/confirmar-celular' },
    })
  }

  function handleShowValidation(value: string) {
    return value.length === 15
  }

  function handleVehiclesTypesSuccess(data: VehicleTypesData) {
    store.update({ vehicle: { types: data } })
  }

  function handleVehiclesBodiesSuccess(data: VehicleBodiesData) {
    store.update({ vehicle: { bodies: data } })
  }

  function handleClose() {
    setOpen(false)
  }

  function handleClickNeedHelp() {
    setOpen(true)
  }

  function handleModalPrimaryClick() {
    window.open(
      `https://api.whatsapp.com/send/?phone=551141181843&text=${encodeURI(
        message,
      )}&app_absent=0`,
      '_blank',
    )
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} aria-labelledby="form-cellphone-title">
      <Title id="form-cellphone-title">
        Precisamos confirmar os seus dados. Vamos lá?
      </Title>
      <Subtitle>Digite o número de celular que você mais usa.</Subtitle>
      <Field
        defaultValue={defaultValues.cellphone}
        mask="(99) 99999-9999"
        name="cellphone"
        label="Celular"
        message="Use um número com WhatsApp, se possível."
        register={register}
        error={errors.cellphone}
        isValid={isValid}
        whenShowValidation={handleShowValidation}
        showSuccess
        type="tel"
      />
      <SubmitButton width="100%" disabled={!isValid}>
        Continuar
      </SubmitButton>
      <Styled.SecondaryButton onClick={handleClickNeedHelp}>
        Preciso de ajuda
      </Styled.SecondaryButton>
      <Modal
        open={open}
        onClose={handleClose}
        title="Está com dificuldades para acessar a Fretebras?"
        message="Entre em contato que nós vamos te ajudar."
        buttons={{ primary: modalButton }}
      />
    </form>
  )
}

export default Cellphone
